import { toast } from 'react-toastify';

export const showToast = {
  success: (message) => {
    toast.success(message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  },
  
  error: (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  },
  
  info: (message) => {
    toast.info(message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  },
  
  warning: (message) => {
    toast.warning(message, {
      position: "top-right",
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }
};

// Individual toast functions for easier import
export const showSuccessToast = (message) => showToast.success(message);
export const showErrorToast = (message) => showToast.error(message);
export const showInfoToast = (message) => showToast.info(message);
export const showWarningToast = (message) => showToast.warning(message);

// Order-specific toast messages
export const orderToasts = {
  placed: () => showToast.success("Order placed successfully!"),
  assigned: (vendorName) => showToast.info(`Order assigned to ${vendorName}`),
  sampleSubmitted: () => showToast.info("Sample submitted for review"),
  sampleApproved: () => showToast.success("Sample approved! Ready for execution"),
  sampleRejected: () => showToast.warning("Sample rejected. Please upload a new sample"),
  documentUploaded: () => showToast.success("Document uploaded successfully"),
  podUploaded: () => showToast.success("Proof of delivery uploaded"),
  orderCompleted: () => showToast.success("Order completed successfully"),
  orderDelivered: () => showToast.success("Order delivered successfully"),
  uploadError: () => showToast.error("Upload failed. Please try again"),
  assignmentError: () => showToast.error("Failed to assign order. Please try again"),
  approvalError: () => showToast.error("Failed to process sample approval. Please try again"),
  updated: () => showToast.success("Order updated successfully"),
  rejected: () => showToast.warning("Order rejected successfully"),
  completed: () => showToast.success("Order marked as completed")
};